import { Fragment, useState } from "react";
import { Combobox, Transition } from "@headlessui/react";
import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";
import MagnifyingGlass from "../assets/menu_icons/magnifyingGlass.svg";
import {  useLocation, useNavigate } from "react-router-dom";
import CustomerSearch from "../pages/customer-page/CustomerSearch";
import CorporationSearch from "../pages/corprate_page/CorporationSearch";
import CustomerApprovedSearch from "../pages/customer_approval/CustomerApproveSearch";
// import NewItemGroupSearch from "../pages/NewItemGroupSearch";
import ItemSearchComponent from "../pages/item-page/ItemSearchComponent";

import SubscriptionSearch from "./SubscriptionSearch";
import FinishItemSearch from "./FinishItemSearch";
import ChartAccountSearch from "../pages/chart_of_account/ChartAccountSearch";
import InvoiceSearch from "../pages/invoice_page/InvoiceSearch";
import PaymentReceiveSearch from "./PaymentReceiveSearch";
import PurchaseOrderSearch from "../pages/purchase_order/purchaseOrderSearch";
import BillSearch from "../pages/bill/BillSearch";
import PurchaseReceiveSearch from "../pages/purchase_receive/PurchaseReceiveSearch";
import SalesOrderSearch from "../pages/sales_order/SalesOrderSearch";
import VoucherOfflineSearch from "../pages/voucher-offline/VoucherOfflineSearch";
import FeatureSearch from "../pages/home_page_feature/FeatureSeaarch";
import PriceListSearch from "../pages/price_list/PriceListSearch";
import CorApprovalSearchBox from "../pages/corporate_approval/CopApprovalSearchBox";
import RatingSearch from "../pages/rating/RatingSearch";
import CarrierBagReturnSearch from "../pages/carreer_bag/CarrierBagReturnSearch";
import ItemGroupSearch from "./ItemGroupSearch";
import VoucherSearchBar from "../pages/vouchers/VoucherSearchBar";
import ProductActionUrlSearch from "../pages/product_action-url/ProductActionURLSearch";
import ProductSharingSearch from "../pages/product-sharing/ProductSharingSearch";
import ManualJournalSearch from "../pages/manual_journals/ManualJournalSearch";
import CreditNoteGeneralSearch from "../pages/credit_note/CreditNoteGeneralSearch";
import VoucherCorpSearch from "../pages/vouchers-corporate/VoucherCorpSearch";
import ExpenseSearch from "../pages/expense/ExpenseSearch";
import RewardEarnSearch from "../pages/reward_history/RewardEarnSearch";
import ProductionSearch from "../pages/production/ProductionSearch";
import WalletTransSearch from "../pages/walletTrans/WalletTransSearch";
import PackageSearch from "../pages/packages/PackageSearch";
import GeneralDebitSearch from "../pages/customer-debit-notes/GenenralDebitSearch";
import SalesOrderReturnSearch from "../pages/sales-order-return/SalesOrderReturnSearch";
import VendorMainSearch from "../pages/vendor/VendorMainSearch";
import StockAdjustmentSearch from "../pages/stock-adjustment/StockAdjustmentSearch";
import PaymentMadeSearch from "../pages/payment-made/PaymentMadeSearch";
import CreditScoreSearch from "../pages/credit_score/CreditScoreSearch";
import OrderDeliverySearch from "../pages/order_delivery/OrderDeliverySearch";


const GeneralSearchBar = () => {


    const { pathname } = useLocation(); 
    var url = pathname.split('/')
    const currModuleId = url[1];
    const currModuleName = url[2];
    const currUserMenu = url[3];

            function showDynamicSearch() {
              switch (currUserMenu) {
                case 'customers':
                  return <CustomerSearch />;
                case 'dashboard':
                  return <CustomerSearch />;
                case 'corporate':
                  return <CorporationSearch />;
                case 'customer-approval':
                  return <CustomerApprovedSearch />;

                case 'item-groups':
                  return <ItemGroupSearch />;
                case 'items':
                  return <ItemSearchComponent />;

                case 'production-entry':
                  return <FinishItemSearch />;
                case 'subscriptions':
                  return <SubscriptionSearch />;
                case 'chart-of-accounts':
                  return <ChartAccountSearch />;
                case 'invoices':
                  return <InvoiceSearch />;
                case 'payment-received':
                  return <PaymentReceiveSearch />;
                case 'purchase-order':
                  return <PurchaseOrderSearch />;
                case 'vendors':
                  return <VendorMainSearch />;
                case 'bills':
                  return <BillSearch />;
                case 'purchase-receives':
                  return <PurchaseReceiveSearch />;
                case 'sales-order':
                  return <SalesOrderSearch />;

                case 'voucher':
                  return <VoucherSearchBar />;
                case 'redeem-offline-voucher':
                  return <VoucherOfflineSearch />;
                case 'feature-action-url':
                  return <FeatureSearch />;
                case 'product-feature-action-url':
                  return <ProductActionUrlSearch />;
                case 'price-list':
                  return <PriceListSearch />;
                case 'corporate-approval':
                  return <CorApprovalSearchBox />;
                case 'grocedy-rating':
                  return <RatingSearch />;
                case 'Carrier-Bag-Return':
                  return <CarrierBagReturnSearch />;
                case 'product-sharing':
                  return <ProductSharingSearch />;
                case 'manual-journals':
                  return <ManualJournalSearch />;
                case 'credit-notes':
                  return <CreditNoteGeneralSearch />;
                case 'corporate-voucher':
                  return <VoucherCorpSearch />;
                case 'expenses':
                  return <ExpenseSearch />;
                case 'Reward':
                  return <RewardEarnSearch />;
                case 'wallet-transactions':
                  return <WalletTransSearch />;
                case 'production':
                  return <ProductionSearch />;
                case 'package-setup':
                  return <PackageSearch />;
                case 'customer-debit-notes':
                  return <GeneralDebitSearch />;
                case 'sales-order-return':
                  return <SalesOrderReturnSearch />;
                case 'stock-adjustment':
                  return <StockAdjustmentSearch />;
                case 'payment-mades':
                  return <PaymentMadeSearch />;
                case 'credit-score':
                  return <CreditScoreSearch />;
                case 'order-delivery':
                  return <OrderDeliverySearch />;

                default:
                  return null;
              }
            }
          

  return (
    <div className="">
     {showDynamicSearch()}
    </div>
  );
};
export default GeneralSearchBar;
